import PageModal from '@components/common/PageModal';
import React, { useEffect, useState } from 'react';
import ZoneForm from './ZoneForm';
import endpoints from '@config/endpoints';
import axios from '../../../../utils/axiosExt';
import { useDispatch, useSelector } from 'react-redux';
import { zoneDetails } from '@constants/index';
import { setZoneType } from '@store/actions/zoneDetailsActions';
import {validations} from '../GeoValidation'
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import CreateCommonComponent from '@components/common/CreateComponent';
import Auth from '../../../../utils/auth';
import { toast } from 'react-toastify';
import { encryptData } from '../../../../utils/base64Utils';
import { EncryptedData } from '../../../../utils/encryptorUtil';
import { getData } from '../../../../services/CommonApiService';
import { errorLogger } from '@utils/applicationLogUtils';
// import pako from 'pako';

interface newUserProps {
  page?: string;
  flow?: string;
}

interface objectType {
  isError: boolean,
  message: string,
  isDisable: boolean,
  value: any,
  id?:any,
  code?:any
}

export interface formStateType {
  [key: string]: objectType
}


const CreateNewGeo: React.FC<newUserProps> = ({ page, flow }: newUserProps) => {
  const storedUserId = localStorage.getItem('userId');
  const storeData: any = useSelector(state => state);
  const dispatch = useDispatch();
  const [zoneDetailsData, setZoneDetailsData] = useState(zoneDetails);
  const [ZDCType, setZDCType] = useState('Zone');
  const [errors, setErrors] = useState<boolean[]>([]);


  // new window code - create new user
  const [navItemsModal, setnavItemsModal] = useState([`${ZDCType} Details`]);
  const navigate = useNavigate();
  const [activeIndex, setActiveIndex] = useState<number>(0);
  const [isFormValidated, setIsFormValidated] = useState<boolean>(false);
  const [formCompleted, setFormCompleted] = useState<boolean[]>(
    Array(navItemsModal.length).fill(false),
  );
  const [closeModal,setCloseModal]=useState<boolean>(false)

  const [selectPerc, setSelectedPerc] = useState<any>(0);
  const navs = 100 / navItemsModal.length;

  const [geoNonGeoFormState,setGeoNonGeoFormState] =useState<formStateType>({
    type: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
    state: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
        id:'',
        code:''
    },
    district: {
        isError: false,
        message: '',
        isDisable: false,
        value: [],
        id:[],
        code:[]
    },
    effective_form_date: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
    zone_name: {
        isError: false,
        message: '',
        isDisable: false,
        value: '',
    },
    // division_name: {
    //     isError: false,
    //     message: '',
    //     isDisable: false,
    //     value: '',

    // },
    // circle_name: {
    //     isError: false,
    //     message: '',
    //     isDisable: false,
    //     value: '',
    // }
  })

  const convertStateData = (data: any) => {
    const result: any = {};
    data.forEach((item: any) => {
      result[item.state_name] = {
        state_name: item.state_name,
        state_code: item.state_code.toString(),
        state_id: item.state_id
      };
    });
    return result;
  }
  const convertDistrictData = (data: any) => {
    const result: any = {};
    data.forEach((item: any) => {
      result[item.district_name] = {
        district_name: item.district_name,
        district_code: item.district_code.toString(),
        district_id: item.district_id
      };
    });
    return result;
  }

  const fetchState = async () => {
    try {  
      // axios.setHeaders({
      //   'x-compress': 'true',
      // });
      const states = await axios.getWithCache(`${endpoints.getStates}`, Auth.loggedIn());
      setZoneDetailsData((zone_details:any) => ({
        ...zone_details,
        state: {
          ...zone_details.state,
          //'#options': convertStateData(JSON.parse(states.data.data)),
          '#options': convertStateData(states?.data?.data),
        //  '#options': convertStateData(JSON.parse(pako.ungzip(states.data.data, { to: 'string' }))),
          },
      }))
    } catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

  const fetchDistrictByStateId = async (state: string) => {
    try{
    const getDist = await axios.get(`${endpoints.getDistrictsforZoneByStateId(state)}`, Auth.loggedIn());
    
    setZoneDetailsData((zone_details:any) => ({
      ...zone_details,
      district: {
        ...zone_details.district,
        '#options': convertDistrictData(getDist.data.data),
        //'#options': getDist.data.data,
        
      },

    }))
  }
  catch(error:any){
    errorLogger(error?.response?.data||error?.response||error)
  }
  }
  useEffect(()=>{
    const initialFetch=async ()=>{
        if (storedUserId) {
          try{
            const res = await getData<any[]>(`${endpoints.getUserById}/${storedUserId}`)
            setGeoNonGeoFormState({
              ...geoNonGeoFormState,
              state:{
                ...geoNonGeoFormState.state,
                  value: res?.data[0]?.state_name ? `${res?.data[0]?.state_name}-${res?.data[0]?.state_code}` : '',
                  id: res?.data[0]?.state_id,
                  code: res?.data[0]?.state_code
                },
                
            });
          }
          catch(error:any){
            errorLogger(error?.response?.data||error?.response||error)
          }
        }
    }
    initialFetch();
},[])

  const handleFormChange = async (value: string | boolean, key: string,option?:any,id?:any,code?:any, ) => {
    setErrors([true]);
    if (key === 'type' && typeof (value) == 'string') {
      // dispatch(setZoneType(value.split("-")[0]));
      if(value==='Division'){
        setZDCType('Division');
        setnavItemsModal([`Division Details`]);
        setZoneDetailsData((zone_details:any) => ({
          ...zone_details,
          zone_name: {
            ...zone_details.zone_name,
            '#title': 'Division Name',    
            },
        }));

      }
      else if(value==='Circle'){
        setZDCType('Circle');
        setnavItemsModal([`Circle Details`])
        setZoneDetailsData((zone_details:any) => ({
          ...zone_details,
          zone_name: {
            ...zone_details.zone_name,
            '#title': 'Circle Name',    
            },
        }))
      }
      else if(value==='Zone'){
        setZDCType('Zone');
        setnavItemsModal([`Zone Details`])
        setZoneDetailsData((zone_details:any) => ({
          ...zone_details,
          zone_name: {
            ...zone_details.zone_name,
            '#title': 'Zone Name',    
            },
        }))
      }
    }
    if (key === 'state' && typeof (value) == 'string') {
      setGeoNonGeoFormState((prevState: any) => ({
        ...prevState,
        ['district']: {
          ...prevState['district'],
          value: '',
          id:'',
          code:''
        },
      }));
    }
 
    setGeoNonGeoFormState((prevState: any) => ({
      ...prevState,
      [key]: {
        ...prevState[key],
        value: value,
        id:id,
        code:code
      },
    }));
  };
  useEffect(()=>{
    if(!geoNonGeoFormState.state.id){
      setGeoNonGeoFormState((prevState: any) => ({
        ...prevState,
        ['district']: {
          ...prevState['district'],
          value: '',
          id:'',
          code:''
        },
      }));
      setZoneDetailsData((zone_details:any) => ({
        ...zone_details,
        district: {
          ...zone_details.district,
          '#options': []
        },
      }))
    }
    {geoNonGeoFormState.state.id && fetchDistrictByStateId(geoNonGeoFormState.state.id)}
  },[geoNonGeoFormState.state.id])


  const getTypeId = (type: string) => {
    switch (type) {
      case 'Zone':
        return 30;
      case 'Division':
        return 31;

      default:
        return 32;
    }
  }


  const getDistrictIds = (districts: any) => {
    if(districts.length!==0){
    const districtNames = districts.map((district: any) => district.split("-")[0]);
    const districtsList = zoneDetailsData.district['#options'];
    return districtNames.map((item: any) => districtsList[item].district_id)
    }
    else{
      return []
    }
  }

  const contents = [
    <div key="zone-details">
      <ZoneForm
        formState={geoNonGeoFormState}
        //handleFormChange={handleFormChange}
        handleFormChange={(value: any, key: string, id: any, option: any, code: any) => {
          if (key === 'district' ) {
            id = [];
            option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
              if (value?.includes(op?.value)) {
                id.push(op?.id);
              }
            });
            code = [];
            option?.length > 0 && value?.length > 0 && option?.forEach((op: any) => {
              if (value?.includes(op?.value)) {
                code.push(op?.code);
              }
            });
           
          }
         
          handleFormChange(value, key,option, id, code);
        }}
        formData={zoneDetailsData}
      />
    </div>
  ];

  const handleSave = async (activeItem: number) => {
    const tempError = [];
    
    let isSimilarName = false;
    if(geoNonGeoFormState.zone_name.value!=='' && geoNonGeoFormState.state.id!==undefined){
    try{
      const response = await axios.get(`${endpoints.checkZoneDivCicleExist(geoNonGeoFormState.state.id,geoNonGeoFormState.zone_name.value)}`, Auth.loggedIn());
      const data1=response.data?.data[0];
      isSimilarName=data1?.check_zone_div_circle_exists;
     

    }
    catch(error:any){
      errorLogger(error?.response?.data||error?.response||error)
    }
  }

 
  const tempChange = {
    ...geoNonGeoFormState
  };
  let isFormError = false;
  
  
  Object.keys(tempChange).map((item: string) => {
    
    if (item === "type") {
      if (!tempChange.type.value) {
        tempChange.type.isError = true;
        tempChange.type.message = validations[item];
        isFormError = true;
        
      }
      else{
        tempChange.type.isError = false;
        
      }
    }
    else if( item === "zone_name"){
        if(!tempChange.zone_name.value){
          tempChange.zone_name.isError = true;
          if(geoNonGeoFormState.type.value==='Division'){
            tempChange.zone_name.message = validations["division_name"];
          }
          else if(geoNonGeoFormState.type.value==='Zone'){
            tempChange.zone_name.message = validations["zone_name"];
          }
          else if(geoNonGeoFormState.type.value==='Circle'){
            tempChange.zone_name.message = validations["circle_name"];
          } 
          else{
            tempChange.zone_name.message = validations["zone_name"];
          } 
          isFormError = true;
          
        }
        else if(isSimilarName){
          isFormError = true;
          
          tempChange.zone_name.isError = true;
          if(geoNonGeoFormState.type.value==='Division'){
            tempChange.zone_name.message = validations["zone_exists"];
          }
          else if(geoNonGeoFormState.type.value==='Zone'){
            tempChange.zone_name.message = validations["zone_exists"];
          }
          else if(geoNonGeoFormState.type.value==='Circle'){
            tempChange.zone_name.message = validations["zone_exists"];
          } 
        }
        else{
          tempChange.zone_name.isError = false;
          
        }
      }
      else if( item === "state" ){
        if (tempChange.state.value==='') {
          tempChange.state.isError = true;
          tempChange.state.message = validations[item];
          isFormError = true;
          
        }
        else{
          tempChange.state.isError = false;
          
        }
      }
      else if(item === "effective_form_date"){
  
        if (!tempChange.effective_form_date.value) {
          tempChange.effective_form_date.isError = true;
          tempChange.effective_form_date.message = validations[item];
          isFormError = true;
          
        }
        else{
          tempChange.effective_form_date.isError = false;
          
        }
      }
      else if((item === "district")){

       // && zoneDetailsData.district['#required']
       const districtKeys = Object.keys(zoneDetailsData.district['#options'])
        if (tempChange.district?.value?.length === 0 && zoneDetailsData.district['#required'] && districtKeys?.length > 0) {
          tempChange.district.isError = true;
          tempChange.district.message = validations[item];
          isFormError = true;
          
        } else if(tempChange.district?.value?.length === 0 && zoneDetailsData.district['#required'] && districtKeys?.length == 0){
          tempChange.district.isError = true;
          tempChange.district.message = 'No districts available to map. All the districts are allocated.';
          isFormError = true;
          
        }
        else{
          tempChange.district.isError = false;
          
        }



      }
   
  });
  tempError[0] = isFormError;
  setGeoNonGeoFormState(tempChange);
  setErrors(tempError);
}

  const finishHandler = async () => {
    const index = geoNonGeoFormState.state.value.split("-")[0];
    
   // const { state_code, state_id } = zoneDetailsData.state['#options'][index];
    const postData: any = {
      "stCode": geoNonGeoFormState.state.code,
      "stateId": geoNonGeoFormState.state.id,
      "zoneDivCircleName":geoNonGeoFormState.zone_name.value,
      "typeId": getTypeId(geoNonGeoFormState.type.value),
      "effectiveFromDt": new Date(dayjs(geoNonGeoFormState.effective_form_date.value).format('YYYY-MM-DD')).toISOString().split('T')[0],
      //"districtIds": getDistrictIds(geoNonGeoFormState.district.value),
      "districtIds": geoNonGeoFormState.district.id,
      //"districtCodes": geoNonGeoFormState.district.value.length!==0?geoNonGeoFormState.district.value.map((d: any) => Number(d.split("-")[1])):[],
      "districtCodes": geoNonGeoFormState.district.code,
      "parentUserId":'',
      "parentUserTypeId":''
    }

    const encryptedPayload:EncryptedData =await encryptData(postData)  
    

    const response: any = await axios.post(`${endpoints.insertZoneDivCir}`, encryptedPayload, Auth.loggedInWithJSON());
    if (response?.status === 200) {
      navigate(`/zone`);
      toast.success("Records have been successfully created", {
        position: "top-center"
      });
    }
    return false;
  };

  useEffect(() => {
    setIsFormValidated(false);
  }, [activeIndex]);

  useEffect(() => {
    if (!errors[activeIndex] && isFormValidated) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = true;
      setFormCompleted(newFormCompleted);
      const perc = (activeIndex + 1) * navs;
      setSelectedPerc(perc);
    }
    if (errors[activeIndex] && formCompleted[activeIndex]) {
      const newFormCompleted = [...formCompleted];
      newFormCompleted[activeIndex] = false;
      setFormCompleted(newFormCompleted);
    }
  }, [errors]);

  const breadcrumbItemName=[
    { value: page, label: 'Geographical Entities' },
    { value: page, label: `Create ${ZDCType}` },
  ];

  const onHandleBackArrowButton=()=>{
    navigate(`/zone`);
  };

  const handleNavClick = (index: number): void => {
    if (formCompleted[index]) {
      setActiveIndex(index);
    }
  };

  const handleSubmit = (): void => {
    handleSave(activeIndex);
    setIsFormValidated(true);
  };

  const CloseFacility=()=>{
    setCloseModal(true);
  };

  const closeCreateModal=(value:boolean)=>{
    if(value){
      setCloseModal(false);
      navigate(`/zone`);
    }
    else{
      setCloseModal(false);
    }
  };


  return (
    <>
    {/* <PageModal
        finishHandler={finishHandler}
        closeModal={closeModal}
        show={show}
        navItemsModal={[`${ZDCType} Details`]}
        contents={contents}
        title={`Create ${ZDCType}`}
        onSave={handleSave}
        errors={[...errors]}
        page='createzonedevcircle'
    /> */}
      <CreateCommonComponent 
        breadcrumbItemName={breadcrumbItemName} 
        onHandleBackArrowButton={onHandleBackArrowButton}
        navItemsModal={navItemsModal}
        activeIndex={activeIndex}
        handleNavClick={handleNavClick}
        formCompleted={formCompleted}
        headerName={`Create ${ZDCType}`}
        progressBarPerc={selectPerc}
        contents={contents}
        handleSubmit={handleSubmit}
        finishHandler={finishHandler}
        handleCancel={CloseFacility}
        closeCreateModal={closeCreateModal}
        closeModal={closeModal}
      />
    </>
  );
  
}

export default CreateNewGeo;
